<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"
    class="transport-option-gc-connection-dialog">

    <sc-dialog-title>{{'global connect connection of option' | translate:['tmc-yard.widgets.sac-client.transport-option-gc-connection-dialog.title',
        translationService.language]}}</sc-dialog-title>
    <sc-separator-line></sc-separator-line>

    <sc-flex-fitting-content [vertical]="true">

        <sc-padding>

            <sc-flex [fitHeight]="true" [centered]="true" [vertical]="true">
                <ng-container [formGroup]="optionSelectionFormGroup">
                    <mat-form-field class="option-selection">
                        <mat-select formControlName="option" name="option">
                            <mat-option *ngFor="let option of optionsWithCase" [value]="option">
                                {{option.nameDictionaryKey | translate: [option.nameDictionaryKey,
                                translationService.language]}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>

                <div class="qr-code-box">
                    <qrcode *ngIf="qrCodeUrl" [qrdata]="qrCodeUrl" [scale]="8"></qrcode>
                </div>
            </sc-flex>

        </sc-padding>
    </sc-flex-fitting-content>

    <sc-separator-line></sc-separator-line>

    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button mat-dialog-close (click)="closeDialog()">{{'cancel' |
            translate:['shared.selection-dialog.action.close',
            translationService.language]}}</button>
    </sc-actionbar>

</sc-flex>
